<template>

  <HeaderSection />

  <section id="formulario" class="bg-gray-100 py-12 font-custom-light min-h-screen">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-black">

      <div class="container mx-auto px-4 max-w-7xl">
        <h3 class="text-xl md:text-3xl text-center font-custom-bold">Pre inscripción</h3>
        <h3 class="md:text-lg text-left mt-3">&bull; Si sos ISP, cooperativa, o cable operador <span class="font-custom-bold">por favor completá el formulario para acceder a las promociones</span>. Validaremos tu información, y te enviaremos un mail con los datos para adquirir la entrada.</h3>
        <h3 class="md:text-lg text-left mt-1">&bull; Si sos proveedor de equipamiento y soluciones para carriers, operadores e ISPs completa el formulario para adquirir tu entrada.</h3>
        
        <h3 class="text-xl font-custom-bold text-center pt-12 md:pt-16">Por favor completá el formulario en su totalidad</h3>

        <!-- Formulario -->
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">¿En que sector trabajás?</label>
            <Field name="tipoAcreditado" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.tipoAcreditado">
                <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccioná el sector" class="input-base" :options="tiposAcreditados" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="tipoAcreditado" /></span>
            </Field>
          </div>
        </div>        

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Documento</label>
            <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Documento" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="dni" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-5/12">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Nombre" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"  />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-5/12">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Apellido" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>          
        </div>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">         
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Empresa</label>
            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Empresa" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"  />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Cargo</label>
            <Field name="cargo" v-slot="{ field, errors }" v-model="formData.cargo">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Cargo" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"  />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" class="input-base" placeholder="Mail" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
        
        </div>  

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-3/12">
              <label class="block mb-1">País</label>
              <Dropdown v-model="selectedCountry" filter :options="paises" optionLabel="value" placeholder="Select a Country" class="input-base"/>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de país</label>
            <InputText type="text" v-if="selectedCountry !== null" v-model="selectedCountry.code" class="input-base" readonly />
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Código de área</label>
            <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
              <InputText v-bind="field" type="text" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoArea" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Teléfono celular</label>
            <Field name="numeroTelefono" v-slot="{ field, errors }" v-model="formData.numeroTelefono">
              <InputText v-bind="field" type="text" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="numeroTelefono" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">
            <div class="w-full px-2">
              <label class="block mb-1">Web</label>
              <Field name="web" v-slot="{ field, errors }" v-model="formData.web">
                <InputText v-bind="field"  class="input-base" placeholder="Ingrese su sitio web" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="web" /></span>
              </Field>
            </div>
        </div>


        <div v-show="formData.tipoAcreditado?.id == 2015">
      
          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">
            <div class="w-full px-2">
              <label class="block mb-1">¿En qué vas e invertir durante 2026?</label>
              <Field name="invertir" v-slot="{ field, errors }" v-model="formData.invertir">
                <Textarea v-bind="field"  class="input-base" placeholder="" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="invertir" /></span>
              </Field>
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">
            <div class="w-full px-2">
              <label class="block mb-1">¿Sobre qué temas te interesa escuchar?</label>
              <Field name="temas" v-slot="{ field, errors }" v-model="formData.temas">
                <Textarea v-bind="field"  class="input-base" placeholder="" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="temas" /></span>
              </Field>
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
            <div class="w-full px-2">
              <label class="block mb-1">¿Cuántos abonados a internet tiene tu compañía?</label>
              <Field name="cantidadAbonados" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.cantidadAbonados">
                  <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccioná una opción" class="input-base" :options="abonados" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
                  <span class="text-sm text-red-500 p-error"><ErrorMessage name="abonado" /></span>
              </Field>
            </div>
          </div>   
          
        </div>
        
        <div v-show="formData.tipoAcreditado?.id == 2018">

          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
            <div class="w-full px-2">
              <label class="block mb-1">¿Cuál es tu principal objetivo para asistir a Nplay?</label>
              <Field name="objetivo" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.objetivo">
                  <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccioná una opción" class="input-base" :options="objetivos" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
                  <span class="text-sm text-red-500 p-error"><ErrorMessage name="objetivo" /></span>
              </Field>
            </div>
          </div>        

          <div v-show="formData.objetivo?.id == 'Otros (indicar cuáles)'">
            <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">
              <div class="w-full px-2">
                <label class="block mb-1">Indicá cuales son los objetivos de tu visita</label>
                <Field name="otrosObjetivos" v-slot="{ field, errors }" v-model="formData.otrosObjetivos">
                  <Textarea v-bind="field"  class="input-base" placeholder="" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                  <span class="text-sm text-red-500 p-error"><ErrorMessage name="otrosObjetivos" /></span>
                </Field>
              </div>
            </div>            
          </div>


      </div>

        <div class="flex flex-wrap py-2 gap-3 justify-center">
          <button type="submit" class="mt-8 px-4 py-2 bg-transparent border border-black hover:bg-black text-black font-semibold hover:text-white rounded" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>ENVIAR
          </button>
        </div>

        <!--
        <div class="text-lg  pt-6">&bull; Si ya estas acreditado y no te llego el correo podes descargar tu credencial con el DNI haciendo <a class="font-semibold" href="/nplay/credencial">click aquí</a></div>
        -->
      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />

    </Form>

  </section>
</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import BlockUI from 'primevue/blockui';
import Textarea from 'primevue/textarea';
import HeaderSection from '@/components/HeaderSection.vue'

import jsonTiposAcreditados from '@/data/tiposAcreditados.json';
import jsonAbonados from '@/data/abonados.json';
import jsonObjetivos from '@/data/objetivos.json';
import jsonCountries from '@/data/countries.json';

import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado, OrigenAcreditado } from 'qreventos-suite/services';
import { ORIGEN_ACREDITADO, A_VERIFICAR, SAVE } from "qreventos-suite/constantes";
import suiteConfig from '@/services/suite.config';

interface Abonado {
  id: string;
  descripcion: string;
}

interface Objetivo {
  id: string;
  descripcion: string;
}

interface Pais {
  code: string;
  value: string;
}


export default defineComponent({
  components: {
    HeaderSection,
    InputText, Dropdown, Textarea,
    Field, ErrorMessage, Form, BlockUI
  },
  data() {
    return {
      isSubmitting: false,
      tiposAcreditados:[] as TipoAcreditado[],
      abonados: [] as Abonado[],
      objetivos: [] as Objetivo[],
      paises: [] as Pais[],
      selectedCountry: {"code": "+54", "value": "Argentina"} as Pais,
      formData: {
        tipoAcreditado: undefined as unknown as TipoAcreditado,
        
        dni: '',
        nombre: '',
        apellido: '',
        mail: '',
        cargo:'',
        empresa: '',
        telefono: '',
        codigoArea: '',
        numeroTelefono: '',
        web: '',
        invertir: '',
        temas: '',
        cantidadAbonados: undefined as unknown as Abonado,
        
        objetivo: undefined as unknown as Objetivo,
        otrosObjetivos: ''

      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        tipoAcreditado: yup.mixed().required('Seleccioná el sector'),
        dni: yup.string().required('Ingresá tu DNI').min(6, 'Al menos 6 números'),
        nombre: yup.string().required('Ingresá tu nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingresá tu apellido').min(3, 'Al menos 3 letras'),
        empresa: yup.string().required('Ingresá el nombre de la empresa').min(3, 'Al menos 3 letras'),
        cargo: yup.string().required('Ingresá tu cargo').min(3, 'Al menos 3 letras'),
        mail: yup.string().required('Ingresá tu correo').email('Correo inválido'),
        web: yup.string().required('Ingresá tu sitio web'),
        codigoArea: yup.string().required('Código de área').matches(/^\d+$/, 'Solo se permiten números'),
        numeroTelefono: yup.string().required('Ingresá tu celular').matches(/^\d+$/, 'Solo se permiten números'),
        
        // ISP, Cooperativa, Cable operador, operador
        invertir: yup.string().when('tipoAcreditado.id', (key, schema) => {
            return key.toString() === '2015'
              ? schema.required('Ingresá en que vas a invertir en el 2026').min(10, 'Al menos 10 letras')
              : schema.notRequired();
        }),

        temas: yup.string().when('tipoAcreditado.id', (key, schema) => {
            return key.toString() === '2015'
              ? schema.required('Ingresá sobre que temas te interesaría escuchar').min(10, 'Al menos 10 letras')
              : schema.notRequired();
        }),

        cantidadAbonados: yup.mixed().when('tipoAcreditado.id', (key, schema) => {
            return key.toString() === '2015'
              ? schema.required('Seleccioná la cantidad de abonados')
              : schema.notRequired();
        }),

        // Proveedores de equipamiento y soluciones de conectividad
        objetivo: yup.mixed().when('tipoAcreditado.id', (key, schema) => {
            return key.toString() === '2018'
              ? schema.required('Seleccioná el objetivo de tu visita')
              : schema.notRequired();
        }),

        otrosObjetivos: yup.string().when('objetivo.id', (key, schema) => {
            return key.toString() === 'Otros (indicar cuáles)'
              ? schema.required('Indicá el objetivo de tu visita').min(20, 'Al menos 20 letras')
              : schema.notRequired();
        }),

      });      
    }
  },
  methods: {
    cancelarAcreditacion() {
      this.$router.go(0);
    },
    async onSubmit() {
      this.isSubmitting = true;

      try {
        let acreditadoExistente:Acreditado = await suiteService.findAcreditadoByDni(suiteConfig.evento, this.formData.dni);
        if(acreditadoExistente) {
            Swal.fire({ title: "Error", text: 'Ya estás registrado con este documento', icon: "error" });
            this.isSubmitting = false;
            return;
        }

        

        let acreditado: Acreditado = {} as Acreditado;
        acreditado.tipoAcreditado = this.formData.tipoAcreditado;
        acreditado.origenAcreditado = { "id" : ORIGEN_ACREDITADO } as OrigenAcreditado;
        acreditado.estadoAcreditado = { "id": A_VERIFICAR } as EstadoAcreditado;
        acreditado.dni = this.formData.dni;
        acreditado.nombre = this.formData.nombre;
        acreditado.apellido = this.formData.apellido;
        acreditado.mail = this.formData.mail;
        acreditado.telefono = this.selectedCountry.code + this.formData.codigoArea + this.formData.numeroTelefono;
        acreditado.empresa = this.formData.empresa;
        acreditado.cargo = this.formData.cargo;
        acreditado.cantidad = 1;
        acreditado.notificar = true;
        acreditado.modificado = SAVE;        

        acreditado.dato1 = this.formData.invertir;
        acreditado.dato2 = this.formData.temas;
        acreditado.dato3 = this.formData.cantidadAbonados?.id;
        acreditado.dato4 = this.formData.objetivo?.id;
        acreditado.dato5 = this.formData.otrosObjetivos;
        acreditado.dato6 = this.formData.web;

        if (this.formData.tipoAcreditado.id == 2015 &&   new Date().getMonth() === 0 ) {
          acreditado.dato7 = "SI";
        }

/*       
        acreditado.datos = {} as any;
        acreditado.datos["5727"] = this.formData.invertir;
        acreditado.datos["5728"] = this.formData.temas;
        acreditado.datos["5729"] = this.formData.cantidadAbonados?.id;
        acreditado.datos["5730"] = this.formData.objetivo?.id;
        acreditado.datos["5731"] = this.formData.otrosObjetivos;
*/

        await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);

        this.isSubmitting = false;
        Swal.fire({
          title: "¡Ya estás pre acreditado!",
          html: "En breve te enviaremos un mail con con el estado de tu acreditación.<br/><br/>Revisá tu casilla de correo y spam.",
          icon: "success",
        }).then(() => {
          window.location.href = "https://www.nplay.convergencia.com";
        });
        

      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
    },
  },
  async mounted() {
    this.tiposAcreditados = jsonTiposAcreditados;
    this.abonados = jsonAbonados;
    this.objetivos = jsonObjetivos;
    this.paises = jsonCountries;
  }
});
</script>